import convertToTitleCase from 'src/utils/convertToTitleCase';

const colors = {
  red: '#D74E45',
  orange: '#FF9800',
  yellow: '#FDD835',
  lime: '#C0CA33',
  green: '#4CAF50',
  blue: '#6CBDE3',
  indigo: '#5C6BC0',
  purple: '#BA79D7',
  pink: '#FF6EA5',
  grey: '#737373',
  black: '#303030',
};

export default {
  colors,
  colorFromLabel: (label: string) => {
    const keys = Object.keys(colors);
    const intValue = label.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

    return colors[keys[intValue % keys.length]];
  },
  entries: Object.entries(colors).map(([name, color]) => ({ name: convertToTitleCase(name), color })),
};
